import { render, staticRenderFns } from "./AppScopeInMaintenance.vue?vue&type=template&id=54cd2644&scoped=true&"
import script from "./AppScopeInMaintenance.vue?vue&type=script&lang=js&"
export * from "./AppScopeInMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cd2644",
  null
  
)

export default component.exports